module.exports = __webpack_public_path__ + "static/fonts/BMKkubulim.otf?d35cc1bf";